export const itilColors = {
  navy: '#1F3864',
  action: '#2f6fd0',
  actionHover: '#255bb0',
  origBg: '#f7f9fb',
  origBorder: '#dde4ec',
  itilBg: '#eef6fb',
  itilBorder: '#bcd9e8',
  ok: '#1f7a4d',
  warn: '#9a6a12',
  req: '#c0392b',
  inkSoft: '#5a6678'
} as const;

export const itilFieldBoxSx = {
  border: '1px solid #dbe3ec',
  borderRadius: '8px',
  background: '#fbfdff',
  p: '14px 16px 12px',
  boxShadow: '0 1px 2px rgba(31,56,100,.06), 0 1px 3px rgba(31,56,100,.05)'
};

export const itilColumnSx = {
  orig: {
    border: `1px solid ${itilColors.origBorder}`,
    borderRadius: '6px',
    background: itilColors.origBg,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: 140
  },
  itil: {
    border: `1px solid ${itilColors.itilBorder}`,
    borderRadius: '6px',
    background: itilColors.itilBg,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: 140
  }
};

export const itilTranslateBtnSx = {
  textTransform: 'uppercase',
  fontWeight: 700,
  fontSize: '11.5px',
  letterSpacing: '0.04em',
  color: itilColors.navy,
  borderColor: '#9cc3da',
  bgcolor: '#fff',
  px: 2,
  py: 1,
  '&:hover': { bgcolor: '#dceaf3', borderColor: '#9cc3da' }
};

export const itilConsolidatedPanelSx = {
  border: `1px solid ${itilColors.itilBorder}`,
  borderRadius: '8px',
  bgcolor: itilColors.itilBg,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  boxShadow: '0 1px 2px rgba(31,56,100,.06)',
  position: { md: 'sticky' },
  top: { md: 62 }
};
